import { Check } from "lucide-react";
import type { AiPipelineAccentStyle } from "./aiPipelineAccentStyles";

export type AiPipelineStepListProps = {
  steps: string[];
  activeStepIndex: number;
  activeStepActivityHint?: string;
  accent: AiPipelineAccentStyle;
  compact?: boolean;
  reducedMotion?: boolean;
};

export const AiPipelineStepList = ({
  steps,
  activeStepIndex,
  activeStepActivityHint,
  accent,
  compact = false,
  reducedMotion = false,
}: AiPipelineStepListProps) => {
  return (
    <ul
      className={`flex w-full flex-col ${compact ? "gap-1" : "gap-2"}`}
      aria-label="Estimated stages"
    >
      {steps.map((step, index) => {
        const isComplete = index < activeStepIndex;
        const isActive = index === activeStepIndex;
        const stepClass = isActive
          ? accent.stepActive
          : isComplete
            ? accent.stepComplete
            : accent.stepIdle;

        return (
          <li
            key={step}
            className={`flex items-start gap-2 text-sm ${stepClass} ${isActive ? "font-medium" : ""}`}
            aria-current={isActive ? "step" : undefined}
          >
            <span
              className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                isComplete
                  ? "border-current/40 bg-current/10"
                  : isActive
                    ? `border-current/50 bg-current/15 ${reducedMotion ? "" : "animate-pulse"}`
                    : "border-border bg-muted"
              }`}
              aria-hidden
            >
              {isComplete ? <Check className="h-2.5 w-2.5" strokeWidth={3} /> : null}
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-0.5">
              <span>{step}</span>
              {isActive && activeStepActivityHint ? (
                <span className={`text-xs font-normal ${accent.mutedText}`}>
                  {activeStepActivityHint}
                </span>
              ) : null}
            </div>
          </li>
        );
      })}
    </ul>
  );
};
